export const PayloadForApplyFilterData = (applyFilterObj, companyDetails) => {
  const has = (k) =>
    applyFilterObj &&
    Array.isArray(applyFilterObj[k]) &&
    applyFilterObj[k].length > 0;

  return {
    general_Manager: has("generalManager")
      ? applyFilterObj.generalManager.join(",")
      : "",
    continantal_Head: has("continentalHead")
      ? applyFilterObj.continentalHead.join(",")
      : "",
    regional_Manager: has("regionalManager")
      ? applyFilterObj.regionalManager.join(",")
      : "",
    area_Manager: has("areaManager")
      ? applyFilterObj.areaManager.join(",")
      : "",
    company_Code: localStorage.getItem("Company_Code"),
    groupIds: has("groupName") ? applyFilterObj.groupName.join(",") : "",
    customer_OrganizationIds: has("custOrganization")
      ? applyFilterObj.custOrganization.join(",")
      : "",
  };
};
